import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from '../environments/environment';
 
const userId = localStorage.getItem('id')
const socketConfig: SocketIoConfig = { url: environment.SOCKET_BASE_URL, options: {
    reconnection: true,
    reconnectionAttempts: 5, // Number of attempts
    reconnectionDelay: 1000, // Delay between attempts (ms)
    transports: ['websocket'], // Use WebSocket transpor
} };

export const SocketConfigModule = SocketIoModule.forRoot(socketConfig);


